import { inject, Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'

import * as UserAccountsSelectors from './user-accounts.selectors'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

@Injectable()
export class UserAccountsFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(UserAccountsSelectors.selectUserAccountsLoaded))
  saving$ = this.store.pipe(select(UserAccountsSelectors.getUserAccountSaving))
  allUserAccounts$ = this.store.pipe(select(UserAccountsSelectors.selectAllUserAccounts))
  selectedUserAccount$ = this.store.pipe(select(UserAccountsSelectors.selectEntity))
  count$ = this.store.pipe(select(UserAccountsSelectors.selectUserAccountsCount))
  searchHistory$ = this.store.pipe(select(UserAccountsSelectors.selectSearchHistory))

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
